import Yup from "../mixins/yup";
import { DischargeType } from "../enums/sintegrada/discharge/DischargeType";

const REQUIRED_MESSAGE = "Campo obrigatório";

export const dischargeFilterSchema = Yup.object().shape({
	startDate: Yup.date().required(REQUIRED_MESSAGE),
	endDate: Yup.date().required(REQUIRED_MESSAGE),
	department: Yup.object().shape({
		label: Yup.string().required(REQUIRED_MESSAGE),
	}),
    dischargeType: Yup.object().shape({
        label: Yup.string().required(REQUIRED_MESSAGE),
    }),
	transferUnit: Yup.object().shape({
		label: Yup.string(),
	}).when("dischargeType", {
		is: (dischargeType: { value: number }) => dischargeType?.value === DischargeType.DischargeByTransfer,
		then: (schema) => schema.shape({
			label: Yup.string().required(REQUIRED_MESSAGE),
		}),
		otherwise: (schema) => schema,
	}),
});
